import MuiButton from './MuiButton';
import MuiCheckbox from './MuiCheckbox';
import MuiIconButton from './MuiIconButton';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiSelect from './MuiSelect';
import MuiSwitch from './MuiSwitch';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTextField from './MuiTextField';
import MuiTypography from './MuiTypography';

export default {
    MuiButton,
    MuiCheckbox,
    MuiIconButton,
    MuiOutlinedInput,
    MuiPaper,
    MuiTableCell,
    MuiTableHead,
    MuiTextField,
    MuiTypography,
    MuiSelect,
    MuiSwitch,
};
